



































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { leaderboard } from '../../../store/leaderboard';
import formatScore from '../../../utils/format-score';

@Component
class CompanyModal extends Vue {
  @Prop() name: string;
  async mounted() {
    await this.$store.dispatch(leaderboard.actions.GetCompanyUsers, this.name);
  }

  async goUserPage(username: string) {
    await this.$emit('close');
    this.$router.push({ name: 'user', params: { username } });
  }

  formatScore(score: number): string {
    return formatScore(score, true, { minimumFractionDigits: 1 });
  }

  userName(user: any) {
    return user.firstname ? `${user.firstname} ${user.lastname}` : user.username;
  }

  get users() {
    return this.$store.getters[leaderboard.getters.CompanyUsers];
  }
}
export default CompanyModal;
